import shave from 'shave';

export default class cardAction {
  
    static get selector() {
        return '.cardAction';
    }
  
    constructor(el) {
        this.el = el;
        this.text = el.querySelector('.cardAction__text');
        if( this.text){
            let lineHeight = parseInt(getComputedStyle(this.text).lineHeight)
            let rect = this.text.getBoundingClientRect();
            console.log(rect.height);
            console.log(parseInt(lineHeight));
            let height = rect.height - (rect.height % lineHeight);
            
            shave(this.text,height,{ character: "..." });
        }
    }
}
  